<template lang="pug">
  .l-short-footer
    .l-short-footer__stamp
      img(src='../../assets/img/shared/courtier-white.png')
      img(src='../../assets/img/shared/feprabel-white.png')
    .l-short-footer__info
      p Lisez ici les <a href="https://s3.eu-central-1.amazonaws.com/seraphin-reference-documents/legal/legal-information.pdf" target="_blank">informations légales</a>, les informations concernant la protection de la <a href="https://s3.eu-central-1.amazonaws.com/seraphin-reference-documents/legal/private-life.pdf" target="_blank">vie privée</a>, les <a href="http://www.sectorcatalog.be/legal?language=1" target="_blank" class="footer-link-list">documents spécifiques</a>, ainsi que les <a href="https://s3.eu-central-1.amazonaws.com/seraphin-reference-documents/legal/terms-and-conditions.pdf" target="_blank">conditions générales</a> d'utilisation du site internet et notre <a href="https://s3.eu-central-1.amazonaws.com/seraphin-reference-documents/legal/cookies-policy.pdf" target="_blank">politique de cookies</a>. &copy; 2018 Seraphin Courtier d’assurance agrée auprès de la FSMA 114863A | BE0639.926.420 | Rue des Francs 79, 1040 Bruxelles (BE) | +32 2 808 11 78 | <a href='mailto:hello@seraphin.be'>hello@seraphin.be</a>
    ul.l-short-footer__list
      li.l-short-footer__item
        a.p-bubble.p-bubble--large(href="https://www.facebook.com/HelloSeraphin/")
          Icon(icon="facebook" classes="p-bubble__icon")
      li.l-short-footer__item
        a.p-bubble.p-bubble--large(href="https://twitter.com/HelloSeraphin")
          Icon(icon="twitter" classes="p-bubble__icon")
      li.l-short-footer__item
        a.p-bubble.p-bubble--large(href="https://www.linkedin.com/company/seraphin")
          Icon(icon="linkedin" classes="p-bubble__icon")
</template>

<script>
import Icon from '../shared/Icon'
export default {
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue